import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/`
});
      api.interceptors.request.use(function(config){
        if(config.method=='post'){ 
        }
        return config
      });
api.initApiErrorHandling = (displaySnackbar,navigation)=>{

  api.interceptors.response.use(
    function (response) { return response; },
    (error)=> handleApiErrors(displaySnackbar,navigation,error)
  )
}
const handleApiErrors = (displaySnackbar,navigation,error)=>{
  if (error.response) {
    if(error.response.status === 401){
      navigation.push('/landing-page/');
      
    }
    else{
    }
    return error.response;
  }
}

window.URL.createObjectURL = function(){};
export default api;


